<template>
  <div class="DevGroup">
    <van-dialog v-model="dialogFormVisible" title="修改分组" show-cancel-button :beforeClose="handleClose">

      <van-cell :title="gname" is-link arrow-direction="down" value="选择分组" @click="gloupseletshow = true" />

      <van-popup v-model="gloupseletshow" position="bottom" :overlay='false' :closeable="true">
        <van-tree-select :items="groupitems" :active-id.sync="activeId" :main-active-index.sync="activeIndex"
          @click-item="clickitem" />
      </van-popup>

    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'DevGroup',
  props: [
    'did'
  ],
  data() {
    return {
      gname: '全部设备',
      gid: '',
      dialogFormVisible: true,
      gloupseletshow: false,
      groupitems: [],
      activeId: 0,
      activeIndex: 0,
      dname: '',
    };
  },
  mounted() {
    this.group_list();
  },
  methods: {
    handleClose(action, done) {
      if (action === 'confirm') {
        done(false);
        this.regroup(this.did, this.gid);
      } else if (action === 'cancel') {
        this.$emit('configstatus', false);
        done(); //关闭
      }
    },
    //获取选择分组设备列表
    clickitem(data) {
      this.gname = data.text;
      this.gid = data.id;
      this.gloupseletshow = false;
    },
    //从后台获取分组信息
    group_list() {
      const qs = require("qs");
      this.$axios.post('api/group/list', qs.stringify({ a: 1 }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.groupitems = this.get_group_list(response.data.grouplist);
          }
          else if (response.data.error_code === 301) {
            this.$router.push({ path: '/login', name: 'login' })
          }

        })
        .catch((error) => {
          console.log(error);
        });
    },
    //将获取到的列表信息格式化成需要用的
    get_group_list(grouplist) {
      var buf = [{ text: '所有设备', children: [{ text: '默认分组', id: '' }] }];
      for (let i in grouplist) {
        var fbuf = {};


        fbuf.id = grouplist[i].gid;
        fbuf.text = grouplist[i].group;

        if (grouplist[i].nextgplist.length != 0) {
          var nbuf = {};
          fbuf.children = [{ text: grouplist[i].group, id: grouplist[i].gid }];
          for (let t in grouplist[i].nextgplist) {
            var nbuf = {};
            nbuf.id = grouplist[i].nextgplist[t].gid;
            nbuf.text = grouplist[i].nextgplist[t].group;
            fbuf.children.push(nbuf);
          }
        }
        else {
          var nbuf = {};
          fbuf.children = [{
            text: grouplist[i].group,
            id: grouplist[i].gid,
          },];
        }
        buf.push(fbuf);
      }
      return buf;
    },
    regroup(did, gid) {
      const qs = require('qs');
      this.$axios.post('/api/dev/group', qs.stringify({ 'gid': gid, 'did': did }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.$emit('configstatus', true);
          }
          else if (response.data.error_code === 301) {
            this.$router.push({ path: '/login', name: 'login' })
          }

        })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import "../../assets/hkapp.css";
</style>